import { string } from "yup";
import { ENV, customerKindEnum, customerTypeEnum } from "../utils";
import { CustomerHasOwnerEnum, SignitureTypeEnum } from "../utils/enum";

export type ConditionProps = {
  customerTypeId: number;
  isForeign: boolean;
  eConversion: boolean;
};

export interface ICustomerList {
  data: ICustomer[];
  errors: null;
  pageNumber: number;
  totalItemCount: number;
}

export interface ICustomer {
  id: string;
  name: string;
  isCustomerOrLead: null | string;
}

export interface IContactCommunication {
  communicationTypeId: string;
  value: string;
  description: string;
  isAcceptedDebtNotify: boolean;
  isAcceptedInvoiceNotify: boolean;
  isAcceptedTechnicalNotify: boolean;
  isAcceptedMarketingNotify: boolean;
  AlarmEmailConfirmation: boolean;
}

interface ICustomerDocument {
  documentDetail: {
    isEDocument: boolean;
    isESignature: boolean;
    startDate: Date;
    endDate: Date | null;
    criteriaDate: Date;
    organizationGroupToRemindedId: string;
    organizationGroupId: string;
    numberOfRenewalsId: number | string;
    refreshPeriodId: number | string;
    startingCriteriaId: number | string;
    notifyMonthId: number | string;
    taxFreeReasonId: string | null;
    archiveInfo: string;
    makeAReminder: boolean;
    isItCommitted: boolean;
    commitmentPeriodId: number | null;
    contractDurationId: number | null;
    stampDuty: number | null;
  };
  description: string;
  customerId: string;
  fileCategoryId: number | null;
  documentId: string;
  file: {
    base64: string;
    fileName: string;
    contentType: string;
  };
}

export const customerDocumentInitials: ICustomerDocument = {
  documentDetail: {
    isEDocument: false,
    isESignature: false,
    startDate: new Date(),
    endDate: null,
    criteriaDate: new Date(),
    organizationGroupToRemindedId: "",
    organizationGroupId: "",
    numberOfRenewalsId: "",
    refreshPeriodId: "",
    startingCriteriaId: "",
    notifyMonthId: "",
    taxFreeReasonId: "",
    archiveInfo: "",
    makeAReminder: false,
    isItCommitted: false,
    commitmentPeriodId: null,
    contractDurationId: null,
    stampDuty: null,
  },
  description: "",
  customerId: "",
  fileCategoryId: null,
  documentId: "",
  file: {
    base64: "",
    fileName: "",
    contentType: "",
  },
};

export interface ICustomerInitials {
  name: string;
  surname: string;
  alias: string;
  commercialTitle: string;
  citizenOrTaxNumber: string;
  email: string;
  customerKindId: number;
  customerTypeId: number;
  ownerId: string;
  adSourceTypeId: number | null;
  dateOfBirth: Date;
  customerCommunication: [];
  customerDetail: {
    isTaxFree: boolean;
    isEInvoiceUser: boolean;
    isSolutionPartner: boolean;
    isActive: boolean;
    isForeign: boolean;
    isCorporateService: boolean;
    supplierTypeId: number;
    eCommerceDescription: string;
    technicalEmail: string;
    partnerLevelId: number;
    customerCode: string;
    description: string;
    creationSource: string;
    statusId: string;
    isSupplier: boolean;
    isBusinessPartner: boolean;
    isPublicCustomer: boolean;
    mersisNo: string;
    isOperator: boolean;
    operatorCode: string;
    customerBalanceStatusId: string;
  };
  address: {
    isDefaultAddress: boolean;
    isForeign: boolean;
    name: string;
    detail: string;
    nationalityId: string | number;
    city: string;
    town: string;
    towShip: string;
    village: string;
    district: string;
    street: string;
    bulding: string;
    door: string;
    addressDetail: {
      postalCode: string;
      vsatId: string;
      uniqueAddressCode: number;
      bbkCode: number;
      addressLocationId: string;
      addressTypeId: string;
      buildingNumber: string | null;
      doorNumber: string;
      adressNotFound: boolean;
      idCity: string;
      cityName: string;
      idTown: string;
      townName: string;
      idTowShip: string;
      towShipName: string;
      idVillage: string;
      villageName: string;
      idDistrict: string;
      districtName: string;
      idStreet: string;
      csbmName: string;
      csbmCode: string;
      idBulding: string;
      buldingName: string;
      doorNo: string;
    };
  };
  contact: {
    name: string;
    surname: string;
    isAuthorizedSignature: boolean;
    titleId: number;
    dateOfBirth: string;
    identityNo: string;
    nationalityId: string;
    departmentId: string;
    jobTitleId: string;
    kvkkMarkApprovalMailSend: boolean;
    kvkkMarkApprovalSmsSend: boolean;
    kvkkMarkApprovalEmail: string;
    kvkkMarkApprovalSms: string;
    signitureTypeId: number | string;

    contactIdentityInformation: {
      fatherName: string;
      motherName: string;
      documentNo: string;
      familyOrdernumber: string;
      orderNo: string;
      serialNo: string;
      volumeNo: string;
      motherMaidenName: string;
      validDate: string;
      placeOfBirth: string;
      countryEntranceDate: string;
      identityProvince: string;
      identityTown: string;
      issuedBy: string;
    };
    contactCommunications: [
      {
        value: string;
        description: string;
        communicationTypeId: number;
      }
    ];
  };
}

export const customerInitials = {
  name: "",
  surname: "",
  alias: "",
  commercialTitle: "",
  citizenOrTaxNumber: "",
  email: "",
  customerKindId: customerKindEnum.indivual,
  customerTypeId: customerTypeEnum.real,
  ownerId: "",
  adSourceTypeId: null,
  customerDetail: {
    leadToCustomerDate: "",
    isTaxFree: false,
    isEInvoiceUser: false,
    isForeign: false,
    isSolutionPartner: false,
    isCorporateService: false,
    isBusinessPartner: false,
    isSupplier: false,
    isOperator: false,
    supplierTypeId: "",
    eCommerceDescription: "",
    technicalEmail: "",
    businessPartnerId: "",
    partnerLevelId: "",
    customerCode: "",
    description: "",
    creationSource: "",
    parentId: "",
    customerId: "",
    adSourceId: "",
    conditionId: "",
    sectorId: process.env.REACT_APP_SECTORID,
    statusId: "",
    taxFreeReasonId: "",
    customerBalanceStatusId: "",
    taxOfficeId: "",
    taxOfficeName: "",
    isSubsidiary: false,
    isPublicCustomer: false,
    mersisNo: "",
    isActive: true,
    eConversion: false,
    isBlueCardCitizen: false,
    operatorCode: "",
  },
  address: {
    isDefaultAddress: true,
    name: "Varsayılan Adres",
    detail: "",
    addressDetail: {
      postalCode: "",
      longitude: "",
      latitude: "",
      vsatId: "123",
      uniqueAddressCode: 0,
      bbkCode: 0,
      addressLocationId: "",
      addressTypeId: "",
      buildingNumber: null,
      doorNumber: "",
      adressNotFound: false,
      existDbDoor: false,
      existDbBuilding: false,
      idCity: "",
      cityName: "",
      idTown: "",
      townName: "",
      idTowShip: "",
      towShipName: "",
      idVillage: "",
      villageName: "",
      idDistrict: "",
      districtName: "",
      idStreet: "",
      csbmName: "",
      csbmCode: "",
      idBulding: "",
      buldingName: "",
      doorNo: "",
    },
    nationalityId: 1,
    isForeign: false,
    countryName: "",
    ttCityName: "",
    ttTownName: "",
    city: "",
    town: "",
    townShip: "",
    village: "",
    district: "",
    street: "",
    building: "",
    door: "",
  },
  contact: {
    name: "",
    surname: "",
    isAuthorizedSignature: true,
    isAuthorizedPerson: true,
    titleId: 1,
    dateOfBirth: "",
    identityNo: "",
    nationalityId: "187cf1ae-023f-ed11-a5f4-005056a2cd35",
    departmentId: "",
    jobTitleId: "",
    signitureTypeId: SignitureTypeEnum.ElectronicIdentity,
    kvkkMarkApprovalMailSend: true,
    kvkkMarkApprovalSmsSend: false,
    kvkkMarkApprovalEmail: "",
    kvkkMarkApprovalSms: "",

    contactIdentityInformation: {
      fatherName: "",
      motherName: "",
      documentNo: "",
      familyOrdernumber: "",
      orderNo: "",
      serialNo: "",
      volumeNo: "",
      motherMaidenName: "",
      validDate: "",
      placeOfBirth: "",
      countryEntranceDate: "2022-04-14T12:46:42.251Z",
      genderId: 1,
      socialStatusId: "",
      identityCardTypeId: "",
      identityProvince: "",
      identityTown: "",
      issuedBy: "",
    },
    contactCommunication: [
      {
        value: "",
        description: "",
        communicationTypeId: 1,
        contactCommunicationPermission: {
          debt: false,
          invoice: false,
          marketingAndGeneralAnnouncement: false,
          technical: false,
          alarmEmailConfirmation: false,
          alarmSmsConfirmation: false,
        },
      },
      {
        value: "",
        description: "",
        communicationTypeId: 2,
        contactCommunicationPermission: {
          debt: false,
          invoice: false,
          marketingAndGeneralAnnouncement: false,
          technical: false,
          alarmEmailConfirmation: false,
          alarmSmsConfirmation: false,
        },
      },
    ],
    legalPermission: [],
  },
  customerTags: [],
  customerAlarmTypes: [],
  customerAlarmSeverityTypes: [],
  dateOfBirth: "",
  customerCommunications: [],
};

export const customerFilterInitials = {
  title: "",
  citizenOrTaxNumber: "",
  customerCode: "",
  isDeleted: false,
};

export const relatedPersonFilterInitials = {
  name: "",
  surname: "",
  titleId: "",
  jobTitleId: "",
  departmentId: "",
  isAuthorizedSignature: "",
};

export const activitiesFilterInitials = {
  subject: "",
  customerId: "",
  contactId: "",
  activityTypeId: "",
  activityDate: "",
};
export const productsFilterInitials = {
  mainCategoryId: "",
  categoryId: "",
  variantId: "",
  productTypeId: "",
};

export const addressFilterInitials = {
  name: "",
  detail: "",
  nationalityId: "",
  isDefaultAddress: "",
};

export const rivalFirmFilterInitials = {
  settingRivalFirmId: "",
  product: "",
  price: "",
  startDate: "",
  endDate: "",
  description: "",
};

export const documentFilterInitials = {
  description: "",
  startDate: "",
  endDate: "",
  eDocument: "",
  eSignature: "",
  fileCategoryId: "",
};

export const proposalFilterInitials = {
  proposalName: "",
  proposalNumber: "",
  proposalStatus: "",
  acceptancePercentage: "",
  paymentType: "",
  sentDate: "",
  expireDate: "",
};

export const orderFilterInitials = {
  orderNumber: "",
  proposalName: "",
  proposalDesc: "",
  creatorId: "",
  paymentTypeId: "",
  createdDate: "",
};

export const workOrderFilterInitials = {
  workOrderNumber: "",
  title: "",
  description: "",
  organizationGroupId: "",
  priorityId: "",
  typeId: "",
  statusId: "",
};

export const invoiceFilterInitials = {
  invoiceNumber: "",
  creationTime: "",
  dueDate: "",
  invoiceStatusId: "",
  isTransferredToAccountingId: "",
};

export const customerIysFilterInitials = {
  contactId: "",
  legalPermissionTypeId: "",
  legalPermissionStatusId: "",
  channelId: "",
  sendedEmailCount: "",
  sendedSmsCount: "",
  customerId: "",
};

export const customerIysReportInitials = {
  contactId: "",
  channelId: "",
  legalPermissionTypeId: "",
  legalPermissionStatusId: "",
  creationTime: "",
  lastModificationTime: "",
  sendedEmailCount: "",
  sendedSmsCount: "",
};
export interface ISupplierCampaignInitials {
  name: string;
  lastModifierId: string;
}

export const supplierCampaignInitials: ISupplierCampaignInitials = {
  name: "",
  lastModifierId: "",
};
export const supplierCampaignFilterInitials = {
  name: "",
};

export interface ICustomerCommunicationInitials {
  customerCommunication: [];
}
export const customerCommunicatonIntials = {
  customerCommunications: [
    {
      value: "",
      description: "",
      communicationTypeId: 1,
    },
  ],
};

export interface ICustomerCommunication {
  value: string | null;
  description?: string | null;
  communicationTypeId: number | null;
}
export const customerCommunicaton: ICustomerCommunication = {
  value: "",
  description: "",
  communicationTypeId: 1,
};
